var touch_x = -1;
var touch_y = -1;
var touch_t = -1;
var touch_tm = null;

function touch_end() {
	touch_x = -1;
	touch_y = -1;
	touch_t = -1;
	$('#step19 .item_act').css({left: ''}).parent().addClass('anim');
}

$(document).ready(function () {

	$('#step19').on('mousedown touchstart', function (e) {
		if (touch_tm) window.clearTimeout(touch_tm);
		touch_tm = window.setTimeout(touch_end, 1000);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		touch_x = touch.pageX;
		touch_y = touch.pageY;
		touch_t = 0;
	}).on('mousemove touchmove', function (e) {
		if (touch_t == 1 || touch_x == -1) return; // top-botom
		if (touch_t == 2) e.preventDefault(); // left-right
		if (touch_t == -1) return; // for mouse
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		this_x = touch.pageX;
		this_y = touch.pageY;
		if (touch_t == 0) {
			if (Math.abs(this_x - touch_x) > Math.abs(this_y - touch_y) + 2) {
				touch_t = 2;
				e.preventDefault();
			} else if (Math.abs(this_x - touch_x) + 2 < Math.abs(this_y - touch_y)) {
				touch_t = 1;
				return;
			} else {
				return;
			}
		}
		if (touch_tm) window.clearTimeout(touch_tm);
		touch_tm = window.setTimeout(touch_end, 1000);
		if (this_x - touch_x > 50) {
			$('#step19 .a_act').css({left: ''});
			if (!$('#step19 .a:first').hasClass('a_act')) {
				var step19_fl = true;
				$('#step19 .a').each(function () {
					if ($(this).hasClass('a_act')) step19_fl = false;
					else if (step19_fl) $(this).addClass('a_prev');
				});
				$('#step19 .a_act').removeClass('a_act').addClass('a_r');
				$('#step19 .a_prev:last').addClass('a_act').removeClass('a_l');
				$('#step19 .a_prev').removeClass('a_prev');
				$('#step19 .pages .act').removeClass('act').prev().addClass('act');
			}
			touch_end();
			return;
		}
		if (this_x - touch_x < -50) {
			$('#step19 .a_act').css({left: ''});
			if (!$('#step19 .a:last').hasClass('a_act')) {
				var step19_fl = false;
				$('#step19 .a').each(function () {
					if ($(this).hasClass('a_act')) step19_fl = true;
					else if (step19_fl) {
						$(this).addClass('a_next');
						step19_fl = false;
					}
				});
				$('#step19 .a_act').removeClass('a_act').addClass('a_l');
				$('#step19 .a_next').addClass('a_act').removeClass('a_r a_next');
				$('#step19 .pages .act').removeClass('act').next().addClass('act');
			}
			touch_end();
			return;
		}
		$('#step19 .a_act').css({left: this_x - touch_x});
	}).on('mouseup', touch_end);

});
